import React from "react";
import Page from "src/components/Layout/Page";

const Loading = () => {
    return (
        <Page>
            <div></div>
        </Page>
    );
};

export default Loading;
